import { QueryClient } from '@tanstack/react-query';
import {
  GlobalPermission,
  SystemPermission_Permission,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { LoaderFunctionArgs } from 'react-router';
import { getSystemQuery } from '~/shared/api/system.queries';
import {
  requireUserGlobalPermission,
  requireUserPermissionForSystemId,
} from '~/shared/auth/auth-utils';
import { assertIsDefined } from '~/types/assert-type';
import { listSystemDesignAlertsQuery } from '~/shared/api/systemDesignAlerts.queries';
import { ResourceNameIdConverter } from '~/shared/models/ResourceNameIdConverter';
import { listSystemSimulationsQuery } from '~/pages/SystemSimulationsPage/api/systemSimulations.queries';

export const systemAdviceReportPageLoader =
  (queryClient: QueryClient) =>
  async ({ params, request }: LoaderFunctionArgs) => {
    const { systemId } = params;

    assertIsDefined(systemId);

    await requireUserGlobalPermission(
      queryClient,
      request,
      GlobalPermission.WAVIN_ONLY,
    );

    await requireUserPermissionForSystemId(
      queryClient,
      request,
      SystemPermission_Permission.VIEWER,
      systemId,
    );

    const [simulations, system] = await Promise.all([
      queryClient.ensureQueryData(
        listSystemSimulationsQuery({
          systemName: ResourceNameIdConverter.systemIdToName(systemId),
        }),
      ),
      queryClient.ensureQueryData(getSystemQuery(systemId)),
    ]);

    const systemDesignAlerts = await queryClient.ensureQueryData(
      listSystemDesignAlertsQuery(system.name),
    );

    return {
      system,
      simulations,
      systemDesignAlerts,
    };
  };
